/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import React from 'react';
import { FieldLabel } from './FieldLabel';
import { FieldWrapper } from './FieldWrapper';
import { useTranslation } from 'react-i18next';

interface Props {
  wrapperClasses?: string;
  labelClasses?: string;
  label?: string;
  [key: string]: any;
}

export function LabelField({ wrapperClasses, labelClasses, label }: Props) {
  const { t } = useTranslation('form');
  return (
    <FieldWrapper className={wrapperClasses}>
      <FieldLabel labelClasses={labelClasses}>{label ? t(label) : label}</FieldLabel>
    </FieldWrapper>
  );
}
